






































































    import Vue from 'vue';
import Common from '@/utilities/Common';
import { Component, Watch, Ref, Prop } from 'vue-property-decorator';
import ListPageBase from '@/components/ListPageBase';
import Option from '@/models/Option';
import DataTable from '@/components/Common/DataTable.vue';
import { OrderService } from '@/services/OrderService';
import { OrderCasesService } from '@/services/OderCasesService';
import { Order } from '../models/Orders/Order';
import { OrderContract } from '../models/Orders/OrderContract';
import { OrderCaseImportFailure } from '@/models/Orders/OrderCaseImportFailure';
import { UnitaryPatentConstants } from '@/constants/UnitaryPatentConstants';
    import { OrderStatusEnum } from '../models/Orders/OrderStatusEnum';
    import { OrderStatus } from '../models/Orders/OrderStatus';
import FileSaver, { saveAs } from 'file-saver';
@Component({
  components: {
    DataTable
    }
})
export default class OrderContracts extends ListPageBase {
    @Ref('formElement') private readonly formElement: any;
    @Prop({ default: null })
    Contracts!: OrderContract[];
    @Prop({ default: 10 })
    pageSize!: number;

    @Prop({ default: 1 })
    pageNumber!: number;

    @Prop({ default: 10 })
    totalItemCount!: number;

    @Prop({ default: true })
    pagingEnabled!: boolean;
  private orderService: OrderService = new OrderService();
    private orderCaseService: OrderCasesService = new OrderCasesService();
    private tableLoading: boolean = false;
    private displayContracts: OrderContract[] = [];
    private orderStatusList: Option[] = [];
    private finalPageSize: number = 10;
    private finalPageNumber: number = 1;
    private loadingModule: boolean = false;
    private loadingFile: boolean = false;
  private get defaultHeaders(): Array<any> {
    return [
      { 
        text: "Proprietor/Instructor",
        value: "CompanyName",
        align: "start",
        sortable: false,
        width: "15%"
      },
      { 
        text: "Email",
        value: "Email",
        align: "start",
        sortable: false,
        width: "10%"
        },
        {
            text: "Status",
            value: "StatusId",
            align: "start",
            sortable: false,
            width: "10%"
        },
      { 
        text: "Status Note",
          value: "StatusNote",
        align: "start",
        sortable: false,
        width: "10%"
      },
        {
            text: "Actions",
            value: "Actions",
            align: "center",
            sortable: false,
            width: "10%"
        }
    ]
  }
  updatePageData(): void {
    /*this.$nextTick(() => {
      this.tableLoading = true;
    });

    this.orderCaseService.getOrderCases({
      pageNumber: this.pageNumber,
      pageSize: this.pageSize
    },this.order.Id)
    .then(success => {
      this.pagedData = success;
    })
    .finally(() => {
      this.tableLoading = false;
    });*/
    }

    private canShowContract(order: Order): boolean {
        return [OrderStatusEnum.Signed].includes(order.StatusId);
    }

    private getOrderCaseContract(item: OrderContract): void {
        this.loadingModule = true;
        this.loadingFile = true;
        this.orderService.getOrderCaseContract(item.Id)
            .then(success => {
                var filename = '';
                var disposition = success.headers.get('Content-Disposition');
                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var matches = filenameRegex.exec(disposition);

                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, '');
                }
                success.blob().then((b: any) => {
                    FileSaver.saveAs(b, decodeURIComponent(filename));
                });
            })
            .catch(error => {
                this.loadingModule = false;
                this.loadingFile = false;
            }).finally(() => {
                this.loadingModule = false;
                this.loadingFile = false;
            });
    }

  get formTitle(): string {
      return "Contracts"; 
  }

    loadData(): void {

    }

  order: Order = {
    OrderNumber: ''
  };

  @Watch('order')
  async onOrderChanged(value: Order): Promise<void>{
    if(value) {
      await this.loadInit()
    }
    }

    async beforeMount() {
        this.displayContracts = this.Contracts;
        this.finalPageSize = this.pageSize;
        this.finalPageNumber = this.pageNumber;

        var orderStatuses = await this.orderService.getOrderStatuses();
        this.orderStatusList = orderStatuses.map((item: OrderStatus) => ({
            text: item.Name,
            value: item.Id
        }));
    }

  onPageChanged(pNumber: number): void {
    this.pageNumber = pNumber;
    this.updatePageData();
  }

  onPageSizeChanged(pSize: number): void {
    this.pageSize = pSize;
    this.updatePageData();
    }

    private setStatusColor(id: OrderStatusEnum): string {
        var result = '--black-color';
        switch (id) {
            case OrderStatusEnum.Created:
                result = '--order-created'
                break;
            case OrderStatusEnum.Uploaded:
                result = '--order-uploaded'
                break;
            case OrderStatusEnum.NoSignature:
                result = '--order-nosignature'
                break;
            case OrderStatusEnum.ToSign:
                result = '--order-tosign'
                break;
            case OrderStatusEnum.Signed:
                result = '--order-signed'
                break;
            case OrderStatusEnum.Lodge:
                result = '--order-lodged'
                break;
            case OrderStatusEnum.Completed:
                result = '--order-completed'
                break;
            case OrderStatusEnum.ToLodge:
                result = '--order-lodged'
                break;
            case OrderStatusEnum.ToReport:
                result = '--order-completed'
                break;
            case OrderStatusEnum.Cancelled:
                result = '--order-cancelled'
                break;
            case OrderStatusEnum.Failed:
                result = '--order-failed'
                break;
        }

        return result;
    }
}
